import { makeStyles } from '@mui/styles';
import blocks from '../../../../Assets/images/Blocks.svg';
import { Theme } from '@mui/material';
import { borderRadius, maxWidth, padding } from '@mui/system';
import { FormatAlignJustify } from '@mui/icons-material';

export const useStyles = makeStyles((theme: Theme) => ({
  section: {
    display: 'flex',
    justifyContent: 'center',
    padding: '60px 0px',
    background: 'linear-gradient(190deg, #FFF 7.64%, #FDF1DC 85.06%, #FFDA9A 115.77%)',
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-20px',
      right: '0px',
      width: '100%',
      height: '300px',
      backgroundImage: `url(${blocks})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'right',
      pointerEvents: 'none',
      zIndex: 0,
    },
  },
  content: {
    width: '90%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '66px',
    width: '85%',
    margin: '0 auto',
    flexWrap: 'wrap',
    '@media (max-width: 963px)': {
      marginBottom: '36px',
    },
    '@media (min-width: 2200px)': {
      width: '80%',
    },
    '@media (max-width: 2000px)': {
      width: '88%',
    },

    '@media (max-width: 1600px)': {
      width: '90%',
    },
    '@media (max-width: 1500px)': {
      width: '100%',
    },
    '@media (max-width: 1100px)': {
      width: '95%',
    },
    '@media (max-width: 768px)': {
      width: '90%',
    },
    '@media (max-width: 480px)': {
      width: '95%',
    },
  },
  title: {
    fontSize: '46px',
    fontWeight: '700 !important',
    color: '#4A4A4A',
    '@media (max-width: 963px)': {
      fontSize: '32px',
    },
  },
  subtitle: {
    marginTop: '10px',
    fontSize: '18px',
    maxWidth: '500px',
    color: '#B67F68',
    '@media (max-width: 963px)': {
      fontSize: '16px',
    },
  },
  cta: {
    background: '#B73601 !important',
    color: '#fff',
    borderRadius: '8px',
    padding: '10px 24px !important',
    textTransform: 'none',
    fontWeight: '600 !important',
    '@media (max-width: 963px)': {
      display: 'none !important',
    },
  },
  cardsWrapper: {
    display: 'grid',
    justifyItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    position: 'relative',

    '@media (min-width: 1438px)': {
      gridTemplateColumns: 'repeat(4, 15vw)',
      gap: '90px',
    },
    '@media (max-width: 1437px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      columnGap: '90px',
      rowGap: '20px',
      margin: '0px auto',
      padding: '35px',
    },
    '@media (max-width: 963px)': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      maxWidth: '100%',
      columnGap: '90px',
      rowGap: '20px',
      padding: '0px',
    },
  },
  card: {
    width: '100%',
    flex: '0 0 240px',
    background: 'linear-gradient(139deg, #FFFCF8 -12.09%, #FFF 182.84%, #FFF 190.37%)',
    borderRadius: '36px',
    padding: '36px',
    position: 'relative',
    boxShadow: '0px -2px 15.5px 0px rgba(255, 226, 184, 0.25), 0px 4px 18px 0px rgba(252, 176, 106, 0.13)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media (max-width: 1437px)': {
      width: '100%',
    },
    '@media (max-width: 963px)': {
      width: '90%',
      padding: '24px',
      borderRadius: '16px',
    },
  },
  step: {
    fontSize: '16px',
    color: '#D5A574',
    fontWeight: 500,
    marginBottom: '8px !important',
    '@media (max-width: 786px)': {
      marginBottom: '4px !important',
    },
  },
  cardTitle: {
    fontSize: '24px',
    fontWeight: '600 !important',
    color: '#B73601',
    marginBottom: '0px !important',
    textWrap: 'nowrap',
    '@media (max-width: 786px)': {
      fontSize: '20px',
      marginBottom: '2px !important',
    },
  },
  cardDesc: {
    fontSize: '14px',
    color: '#A1A1A1',
    marginBottom: '24px !important',
    '@media (max-width: 786px)': {
      marginBottom: '0px !important',
    },
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 'auto',
    padding: '24px 0px',
    '@media (max-width : 786px)': {
      height: '5vh',
      alignItems: 'start',
      justifyContent: 'start',
      padding: '5x 0',
    },
  },
  iconImage: {
    width: '70px',
    height: '70px',
    objectFit: 'contain',
  },
  arrow: {
    position: 'absolute',
    top: '40%',
    right: '-5px',
    transform: 'translate(50%, -50%)',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 964px)': {
      display: 'none !important',
    },
  },
  arrowImage: {
    width: '45px',
    height: '45px',
    objectFit: 'contain',
  },
  hideOnSmall: {
    '@media (max-width: 1437px)': {
      display: 'none !important',
    },
  },

  arrowMobile: {
    position: 'absolute',
    bottom: '-30px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width : 786px)': {
      display: 'none',
    },
  },
  arrowImageMobile: {
    width: '45px',
    height: '45px',
    objectFit: 'contain',
  },
  showOnlyOnSmall: {
    '@media (min-width: 964px)': {
      display: 'none !important',
    },
  },
  ApplyNowBtn: {
    display: 'flex',
    background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    backgroundColor: 'rgba(183, 54, 1, 1) !important',
    padding: '0.8vh 2vh !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.8vh',
    fontSize: '1.4vh !important',
    borderRadius: '1.2vh !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: 'rgba(255, 255, 255, 1) !important',
    [theme.breakpoints.down('lg')]: {
      padding: '0.8vh 1.2vh !important',
      fontSize: '1.2vh !important',
      borderRadius: '1.4vh !important',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
}));
